import $ from "jquery";

const gformCheckboxActive = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            main: '.gform_wrapper .gfield .gfield_checkbox .gchoice input[type="checkbox"]'
        }
        if ($(el.main).length === 0) return

        $(function ($) {
            $(el.main).each(function () {
                var $input = $(this);
                var $gchoice = $input.closest('.gchoice');

                // Set active state saat halaman pertama kali load
                if ($input.is(':checked')) {
                    $gchoice.addClass('active');
                }

                // add event listener for update class when changed
                $input.on('change', function () {
                    $gchoice.toggleClass('active', $input.is(':checked'));
                });
            });
        });
    };

    init();
};

try {
    gformCheckboxActive();
} catch (error) {
    console.error('gformCheckboxActive', error);
}
